export const defaultScoringTypes = {
  101: [
    { label: 'Met', value: 1, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  102: [
    { label: 'Met', value: 2, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  104: [
    { label: 'Met', value: 4, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  105: [
    { label: 'Met', value: 5, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  300: [],

  401: [],

  402: [],

  410: [],

  501: [
    { label: '1', value: 1, color: 'green' },
    { label: '0', value: 0, color: 'red' },
  ],

  510: [
    { label: '10', value: 10, color: 'green' },
    { label: '5', value: 5, color: 'orange' },
    { label: '0', value: 0, color: 'red' },
  ],

  700: [],

  103: [
    { label: 'Met', value: 3, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  801: [
    { label: '1', value: 1, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  802: [
    { label: '2', value: 2, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  803: [
    { label: '3', value: 3, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  804: [
    { label: '4', value: 4, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  805: [
    { label: '5', value: 5, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  302: [
    { label: '2', value: 2, color: 'green' },
    { label: '1', value: 1, color: 'orange' },
    { label: '0', value: 0, color: 'red' },
  ],

  601: [
    { label: 'Met', value: 1, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
  ],

  602: [
    { label: 'Met', value: 2, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
  ],

  603: [
    { label: 'Met', value: 3, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
  ],

  604: [
    { label: 'Met', value: 4, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
  ],

  605: [
    { label: 'Met', value: 5, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
  ],

  901: [{ label: 'N/A', value: null, icon: 'no', color: 'grey' }],

  200: [
    { label: 'Met', value: 1, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  202: [
    { label: 'Met', value: 2, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  204: [
    { label: 'Met', value: 4, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  106: [
    { label: 'Met', value: 6, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  108: [
    { label: 'Met', value: 8, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  109: [
    { label: 'Met', value: 9, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  110: [
    { label: 'Met', value: 10, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  112: [
    { label: 'Met', value: 12, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  115: [
    { label: 'Met', value: 15, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  120: [
    { label: 'Met', value: 20, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  125: [
    { label: 'Met', value: 25, icon: 'plus', color: 'green' },
    { label: 'Not Met', value: 0, icon: 'minus', color: 'red' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  203: [
    { label: 'Met', value: 3, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  206: [
    { label: 'Met', value: 6, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  208: [
    { label: 'Met', value: 8, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  209: [
    { label: 'Met', value: 9, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  210: [
    { label: 'Met', value: 10, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  212: [
    { label: 'Met', value: 12, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  215: [
    { label: 'Met', value: 15, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  220: [
    { label: 'Met', value: 20, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  225: [
    { label: 'Met', value: 25, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  503: [
    { label: '4', value: 4, color: '#31a6c9' },
    { label: '2', value: 2, color: '#31a6c9' },
    { label: '0', value: 0, color: '#31a6c9' },
  ],

  504: [
    { label: '6', value: 6, color: '#31a6c9' },
    { label: '4', value: 4, color: '#31a6c9' },
    { label: '2', value: 2, color: '#31a6c9' },
    { label: '0', value: 0, color: '#31a6c9' },
  ],

  505: [
    { label: '4', value: 4, color: '#31a6c9' },
    { label: '3', value: 3, color: '#31a6c9' },
    { label: '2', value: 2, color: '#31a6c9' },
    { label: '1', value: 1, color: '#31a6c9' },
    { label: '0', value: 0, color: '#31a6c9' },
  ],

  506: [
    { label: '12', value: 12, color: '#31a6c9' },
    { label: '6', value: 6, color: '#31a6c9' },
    { label: '0', value: 0, color: '#31a6c9' },
  ],

  507: [
    { label: '20', value: 20, color: '#31a6c9' },
    { label: '10', value: 10, color: '#31a6c9' },
    { label: '0', value: 0, color: '#31a6c9' },
  ],

  508: [
    { label: '9', value: 9, color: '#31a6c9' },
    { label: '6', value: 6, color: '#31a6c9' },
    { label: '3', value: 3, color: '#31a6c9' },
    { label: '0', value: 0, color: '#31a6c9' },
  ],

  205: [
    { label: 'Met', value: 5, icon: 'plus', color: 'green' },
    { label: 'N/A', value: null, icon: 'no', color: 'grey' },
  ],

  902: [{ label: 'N/A', value: null, icon: 'no', color: 'grey' }],
};
